import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_893'),
        action: obj => {
          this.createDialog('ApproveReportProjectDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: (obj) => ({
          validate: obj.status === 'init',
        }),
      },
    ]
  },
}
